import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import { Loader } from '../../../components/Loader';
import { fillVehicleProperty, fetchVehicleProperty } from '../actions';
import { selectVehicleProperty } from '../selectors';

const STATE = {};
/* eslint-disable react/prefer-stateless-function */
class WithVehiclePropertyComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.propertyValue && !this.props.value) {
      this.props.fillVehicleProperty(this.props.vehicleId, this.props.propertyName, this.props.propertyValue);
    }

    if ((!this.props.value && !this.props.propertyValue) || this.props.doFetch) this.props.fetch();
  }

  render() {
    if (this.props.value === undefined) return this.props.loader ? <Loader small /> : this.props.alt || null;
    return this.props.children;
  }
}

WithVehiclePropertyComp.propTypes = {
  propertyValue: PropTypes.any,
  dispatch: PropTypes.func.isRequired,
  vehicleId: PropTypes.number.isRequired,
  propertyName: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    value: selectVehicleProperty(ownProps.vehicleId, ownProps.propertyName),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    fetch() {
      dispatch(fetchVehicleProperty(ownProps.vehicleId, ownProps.propertyName));
    },
    fillVehicleProperty(vehicleId, propertyName, propertyValue) {
      dispatch(fillVehicleProperty(vehicleId, propertyName, propertyValue));
    }
  };
}

const withConnect = connect(
  mapStateToProps,
  mapDispatchToProps,
);

export const WithVehicleProperty = compose(
  withConnect,
  withRouter,
)(WithVehiclePropertyComp);
